import { ValidationSchemaType } from 'hooks/useForm';
import { ProductCategory } from '../types/dtos';

export const PRODUCT_CATEGORY_INITIAL_FIELDS: ProductCategory = {
    name: '',
    isActive: 'ACTIVE',
};

export const PRODUCT_CATEGORY_FIELDS_SCHEMA: ValidationSchemaType<ProductCategory> = {
    name: {
        required: true,
        maxLength: 100,
    },
    isActive: {
        required: true,
    },
};
